import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * The local preview never resolves a field's raw type against `templateFieldTypesStore` itself
 * (`DescribeDocumentTemplateFile` leaves that to its consumer). Falls back to the raw value as its
 * own label when the catalogue has no matching entry yet — the catalogue may still be loading, or the
 * `.docx` may declare a type the front doesn't know about.
 */
function resolveTemplateFieldTypeLabel(
	value: string,
	templateFieldTypes: readonly LabeledValueView[] | null,
): LabeledValueView {
	const found = templateFieldTypes?.find((type) => type.value === value) ?? null;

	if (found !== null) {
		return found;
	}

	return new LabeledValueView({ value, label: value });
}

export default resolveTemplateFieldTypeLabel;
